<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom mb-5">
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Construction Detail {{schoolname}} </h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div>
                                        <div class="card col-mb-6">
                                            <div class="card-header py-3">
                                                <input type="text" class="form-control bg-white border-0 small"
                                                    placeholder="Search for..." [(ngModel)]="searchtext"
                                                    aria-label="Search" aria-describedby="basic-addon2"
                                                    (keyup)="setpage()" />
                                            </div>
                                        </div>
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No. </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('YearOfConstruction')"> Year of construction </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Phase')"> Phase </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Area')"> Area </th>
                                                    <th class="pointer" scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="ConstructionDetaillist != undefined && ConstructionDetaillist.length != 0">
                                                <tr *ngFor="let r of ConstructionDetaillist | filter:searchtext | paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index">
                                                    <td>{{r.SrNo}}</td>
                                                    <td>
                                                        <p>{{r.YearOfConstruction}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.Phase}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.Area}}</p>
                                                    </td>
                                                    <td>
                                                        <button type="button" class="btn btn-danger"
                                                            (click)="deleteConstructionDetail(r.HashCode)">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="ConstructionDetaillist == undefined || ConstructionDetaillist.length == 0">
                                                <tr>
                                                    <td colspan="5" style="text-align: center;">
                                                        No Record Found
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="card-footer pb-0 pt-3" align="right">
                                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-login custom-footer">
            <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
            <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
        </div>
        <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white;">Please Wait.</p>
        </ngx-spinner>
    </div>
</div>